var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading)?_c('portal-menu-skelton-loader'):_c('portal-history-menus-panel',{attrs:{"menus":_vm.menus},on:{"history-menu-opened":_vm.afterMenuOpen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }